import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled", "aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-prev-circled",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "1", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "pagination-ellipsis"
}
const _hoisted_8 = ["aria-current", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: "pagination-ellipsis"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["disabled", "aria-label"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-next-circled",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]

import { computed, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationBar',
  props: {
    current: {},
    total: {}
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;



const i18n = inject('i18n') as { [key: string]: string };



function goToPage (page: number): void {
    emit('select', page);
}

function goToPreviousPage (): void {
    emit('select', props.current - 1);
}

function goToNextPage (): void {
    emit('select', props.current + 1);
}

function isPageCurrent (page: number): boolean {
    return props.current === page;
}

const displayedPages = computed(() => {
    const pages = [];
    let start = Math.max(2, props.current - 1);
    let end = Math.min(props.total - 1, props.current + 1);

    if (props.current <= 3) {
        start = 2;
        end = Math.min(4, props.total - 1);
    }

    if (props.current >= props.total - 2) {
        start = Math.max(props.total - 3, 2);
        end = props.total - 1;
    }

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }
    return pages;
});

const shouldShowLeftEllipsis = computed(() => props.current >= 4);
const shouldShowRightEllipsis = computed(() => props.current <= props.total - 3);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      disabled: props.current === 1,
      class: "button-icon pagination-button-prev",
      "aria-label": _unref(i18n).goToPreviousPage,
      onClick: goToPreviousPage
    }, _hoisted_3, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("button", {
      class: "button-icon",
      "aria-label": _unref(i18n).firstPage,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(1)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['icon', { 'icon-circle': isPageCurrent(1) }])
      }, _hoisted_6, 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_4),
    (shouldShowLeftEllipsis.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "..."))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPages.value, (page) => {
      return (_openBlock(), _createElementBlock("button", {
        key: page,
        "aria-current": isPageCurrent(page) ? 'location' : undefined,
        class: "button-icon",
        onClick: ($event: any) => (goToPage(page))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['icon', { 'icon-circle': isPageCurrent(page) }])
        }, [
          _createElementVNode("span", null, _toDisplayString(page), 1 /* TEXT */)
        ], 2 /* CLASS */)
      ], 8 /* PROPS */, _hoisted_8))
    }), 128 /* KEYED_FRAGMENT */)),
    (shouldShowRightEllipsis.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "..."))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      class: "button-icon",
      "aria-label": _unref(i18n).lastPage,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(props.total)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['icon', { 'icon-circle': isPageCurrent(props.total) }])
      }, [
        _createElementVNode("span", null, _toDisplayString(props.total), 1 /* TEXT */)
      ], 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_10),
    _createElementVNode("button", {
      disabled: props.current === props.total,
      class: "button-icon pagination-button-next",
      "aria-label": _unref(i18n).goToNextPage,
      onClick: goToNextPage
    }, _hoisted_13, 8 /* PROPS */, _hoisted_11)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})